export default {
    getAuthCareerVideos (state) {
        return state.authCareerVideos
    },
    getAuthInspirationVideos (state) {
        return state.authInspirationVideos
    },
    getAuthWorkVideos (state) {
        return state.authWorkVideos
    },
    getAuthLifeVideos (state) {
        return state.authLifeVideos
    },
    getAuthMoneyVideos (state) {
        return state.authMoneyVideos
    },
    getAuthMindbodyVideos (state) {
        return state.authMindbodyVideos
    },
    getAuthRecommendedVideos (state) {
        return state.authRecommendedVideos
    },
    getAuthRecentlyWatchedVideos (state) {
        return state.authRecentlyWatchedVideos
    },
    getAuthQuestions (state) {
        return state.authQuestions
    },
    getAuthUserVideos (state) {
        return state.authUserVideos
    },
    getAuthUserFavVideos (state) {
        return state.authUserFavVideos
    },
    getQuote (state) {
        return state.authQuote
    },
    getAuthGreeting (state) {
        return state.authGreeting
    },
    getAuthFunnies (state) {
        return state.authFunnies
    },
    getToneTakeaways (state) {
        return state.toneTakeaways
    },
    getToneTeasers (state) {
        return state.toneTeasers
    }
}



// WEBPACK FOOTER //
// ./src/store/authpage/getters.js